export class GetSectorsWithFarmsSectorUseCase {
  constructor(sectorHasFarm) {
    this.sectorHasFarm = sectorHasFarm
  }
  async execute(IDS) {
    const resp= await this.sectorHasFarm.getByIdsFarm(IDS)

    return resp
  }
}
